import React from "react";
export function SiteFooter() {
  return <footer className="bg-navy py-10 text-white/65" data-id="element-137" data-mp="1dqrovx7i9m8c">
      <div className="mx-auto flex max-w-[1180px] flex-col gap-4 px-5 text-xs sm:px-8 md:flex-row md:items-center md:justify-between" data-id="element-138" data-mp="3r7py5zkqmj63">
        <p className="font-display text-lg font-bold uppercase tracking-[0.06em] text-white" data-id="element-139" data-mp="3mfyf0a3wvfpz">
          Corporate Training Ready <span className="text-teal-bright" data-id="element-140" data-mp="3hgdehv93ezb5">360</span>
        </p>
        <p className="md:text-right" data-id="element-141" data-mp="3dhmd3bxlgvi8">
          Educational training materials · English-language PDF
          <br data-id="element-142" data-mp="38gymgrda2goj" />
          Not an accredited certification or compliance program. © 2026
        </p>
      </div>
    </footer>;
}